<template>
  <div>
    <van-sticky :offset-top="46" >
      <van-search
        v-model="queryParams.productName"
        shape="round"
        show-action
        background="#4fc08d"
        clearable
        placeholder="请输入搜索关键词"
      >
        <template #action>
          <div style="padding: 0px 4px;" @click="handleRefresh">搜索</div>
        </template>
      </van-search>
      <van-row>
        <van-col span ='24'>
          <van-cell style="border-radius: 6px">
            <template #default>
              <van-row type="flex" justify="space-between" style="background-color:rgba(49,175,237,0.82);line-height: 32px;border-radius: 6px;padding: 6px 10px">
                <van-col span="16">采购日期:{{statistics.deliveryDate}}</van-col>
                <van-col span="8">采购: <span class="loss" style="font-size: 18px">{{statistics.confirmPurchaseQuantity}}</span> 件</van-col>
              </van-row>
            </template>
          </van-cell>
        </van-col>
      </van-row>
    </van-sticky>
    <page-list ref='pageList' request-url="/purchase" :getParams="getQueryParams" :preprocessData="preprocessData">
      <template #row="{index,row}">
        <van-row style="background-color:rgba(172,201,220,0.19);line-height: 32px;border-radius: 6px;padding: 6px 10px">
          <van-col span="21">{{index+1}}. 商品名称: {{row.productName}}</van-col>
          <van-col span="3"><van-switch v-model="row.able" size="16px" @change="handlePrice(row)"/></van-col>
          <van-col span="12">销售价: {{row.price}}</van-col>
          <van-col span="12">结算价: {{row.supplierPrice}}</van-col>
          <van-col span="12">采购价: <span :class="row.purchasePrice > row.price?'loss': (row.purchasePrice > row.supplierPrice?'warn':(row.purchasePrice < row.supplierPrice?'profit':''))">{{row.purchasePrice}}</span></van-col>
          <van-col span="12">
            <div style="display: flex">
              <span style="width: 120px">新销售价:</span>
              <van-field v-model="row.newPrice" type="number" style="padding: 0px 12px;line-height: 32px" :disabled="!row.able"/>
            </div>
          </van-col>
        </van-row>
      </template>
    </page-list>
    <van-submit-bar >
      <template #button>
        <van-button  round block @click="openSettingRatioDrawer">调整比例{{ratio}}%</van-button>
        <van-button type="primary" round block @click="batchChangePrice">提交调价</van-button>
      </template>
    </van-submit-bar>
    <down-drawer ref='ratioDrawer' @close="handleRefresh" @confirm="onSettingRatio" title="调整比例" >
      <template #content>
        <van-form ref="form" :validate-first="true" :show-error-message="false">
          <van-field
            name="priceRatio"
            label="比例"
            input-align ='right'
            :rules="[{ required: true, message: '调整比例不能为空' }]">
            <template #input>
              <van-stepper v-model="model.priceRatio" step="1" :decimal-length="0" :input-width ='64' :min="0"/>
            </template>
          </van-field>
        </van-form>
      </template>
    </down-drawer>
  </div>
</template>

<script>
import { Dialog } from 'vant'
import PageList from '@/components/tools/PageList'
export default {
  name: 'ProductList',
  components: { PageList },
  created () {
    this.queryParams.deliveryDate = this.$moment(new Date()).format('YYYY-MM-DD')
    this.statistics.deliveryDate = this.$moment(new Date()).format('YYYY-MM-DD')
    // 获取当前配送日期的采购信息
    this.getPurchaseStatistics()
  },
  data () {
    const that = this
    return {
      url: {
        imgerver: window._CONFIG.staticDomainUrl
      },
      purchaseVisible: false,
      show: false,
      allOrder: false,
      model: {},
      queryParams: {
        purchaseStatus: 1,
        deliveryDate: '',
        productName: null
      },
      statistics: {
        deliveryDate: '',
        purchaseTotalAmount: 0.00,
        waitPurchaseQuantity: 0,
        confirmPurchaseQuantity: 0
      },
      minDate: new Date(that.$moment(new Date()).subtract(1, 'months').startOf('month').format('YYYY-MM-DD')),
      ratio: 20
    }
  },
  computed: {

  },
  methods: {
    getQueryParams (params) {
      const param = Object.assign({}, params)
      // param.purchaseStatus = this.queryParams.purchaseStatus
      param.reserveStatus = 1
      param.deliveryDate = this.$moment(new Date()).format('YYYY-MM-DD')
      param.productName = this.queryParams.productName
      return { params: param }
    },
    handlePrice (item) {
      if (item.able === true) {
        item.newPrice = (item.purchasePrice * (1 + this.ratio * 0.01)).toFixed(2)
      } else {
        item.newPrice = item.price
      }
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
      // 获取当前配送日期的采购信息
      this.getPurchaseStatistics()
    },
    getPurchaseStatistics () {
      this.$api.shop.getPurchaseStatistics(this.queryParams.deliveryDate).then(response => {
        if (response.success) {
          this.statistics = response.result
        }
      }).catch(() => {
      })
    },
    preprocessData (data) {
      data.forEach(item => {
        if (typeof item.able === 'undefined') {
          item.able = false
        }
        if (item.able === true) {
          item.newPrice = (item.purchasePrice * (1 + this.ratio * 0.01)).toFixed(2)
        } else {
          item.newPrice = item.price
        }
      })
    },
    openSettingRatioDrawer (row) {
      this.model = {}
      this.$set(this.model, 'priceRatio', this.ratio)
      this.$refs.ratioDrawer.show = true
    },
    onSettingRatio () {
      // 触发表单验证
      this.$refs.form.validate().then(() => {
        this.ratio = this.model.priceRatio
        this.$refs.ratioDrawer.show = false
        this.handleRefresh()
      }).catch((err) => {
        console.log('验证失败', err)
      })
    },
    batchChangePrice () {
      Dialog.confirm({
        title: '提示',
        message: '是否确认要调整价格？'
      })
        .then(() => {
          const params = []
          this.$refs.pageList.dataList.forEach(item => {
            if (parseFloat(item.newPrice) > 0) {
              const param = {
                newPrice: item.newPrice,
                oriPrice: item.price,
                prdId: item.productId,
                productName: item.productName
              }
              params.push(param)
            }
          })
          if (params.length > 0) {
            this.$api.shop.batchChangePrice(params).then(response => {
              if (response.success) {
                this.$toast.success('操作成功')
              } else {
                this.$toast.fail(response.message)
              }
            }).catch(() => {
            })
          }
        })
        .catch(() => {
          // on cancel
        })
    }
  }
}
</script>

<style lang="less" scoped>
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
    padding: 8px 0px;
    border-radius: 50%;
  }
  .profit {
    color: #07c160;
  }
  .loss {
    color: #ee0a24;
  }
  .warn {
    color: #ed8b08
  }
</style>
